module.exports = __webpack_public_path__ + "static/media/so-stock--cow3.2156fb91.jpg";